import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useConfig } from '$root/contexts/config';

import {
    PLAN_VIEW_RESIZE_EVENT_TYPE,
    PLAN_VIEW_PAINT_EVENT_TYPE,
    PLAN_VIEW_MOUSEMOVE_EVENT_TYPE
} from './PlanViewAdvanced2.PlanViewEvents';


function PlanViewAdvanced2DrawViewPoints(props, ref)
{
    const { zIndexBase, planView, viewPoints } = props;
    const { config } = useConfig();


    const planViewPaint = (e) => {
        const drawCtx = ref.current.getContext("2d");

        drawCtx.setTransform(1, 0, 0, 1, 0, 0);
        drawCtx.clearRect(0, 0, drawCtx.canvas.width, drawCtx.canvas.height);

        const tr = e.viewTransform;
        //const tr = pdfViewDataRef.current.viewTrMatrix.multiply(pdfViewDataRef.current.viewPointsTrafo);

        viewPoints.forEach((vp) => {
            e.drawViewpoint(drawCtx, vp, tr);
        });

        if (config?.runtime?.showVPNameOnPlan) {
            viewPoints.forEach((vp) => {
                e.drawViewpointLabel(drawCtx, vp, tr);
            });
        }
    };


    const planViewResize = (e) => {
        ref.current.width = e.width;
        ref.current.height = e.height;
    };


    useEffect(() => {
        if (!(planView instanceof HTMLElement))
            return;

        planView.addEventListener(PLAN_VIEW_PAINT_EVENT_TYPE, planViewPaint);
        planView.addEventListener(PLAN_VIEW_RESIZE_EVENT_TYPE, planViewResize);

        const rc = planView.getBoundingClientRect();
        ref.current.width = rc.width;
        ref.current.height = rc.height;

        return () => {
            planView.removeEventListener(PLAN_VIEW_PAINT_EVENT_TYPE, planViewPaint);
            planView.removeEventListener(PLAN_VIEW_RESIZE_EVENT_TYPE, planViewResize);
        };
    }, [planView, viewPoints]);


    return (
        <canvas ref={ref}
                width={1}
                height={1}
                style={{
                    position:'absolute',
                    left:0,
                    top:0,
                    zIndex:zIndexBase,
                    pointerEvents:'none'
                }}>
        </canvas>
    );
}

export default React.forwardRef(PlanViewAdvanced2DrawViewPoints);


PlanViewAdvanced2DrawViewPoints.propTypes = {
    planView:PropTypes.object.isRequired,
    viewPoints:PropTypes.array.isRequired,
    zIndexBase:PropTypes.number,
}


PlanViewAdvanced2DrawViewPoints.defaultProps = {
    zIndexBase:100,
}
